import type { BusinessReportNavigationItem } from '../lib/api/business-reports';

export function BusinessReportUnavailableTab({ active, report }: { active: boolean; report?: BusinessReportNavigationItem }) {
  if (!active) return null;
  return (
    <section className="tab-content" id="tab-business-report">
      <div className="enterprise-card" style={{ maxWidth: 860, margin: '0 auto', padding: 32 }}>
        <p className="eyebrow">Business Reports</p>
        <h2 style={{ marginTop: 0 }}>{report?.name || 'Report unavailable'}</h2>
        <p style={{ color: 'var(--text-muted)', lineHeight: 1.65 }}>
          {report?.description || 'This report is not available for your account.'}
        </p>
        <div className="empty-state" style={{ marginTop: 24 }}>
          <strong>Source configuration pending</strong>
          <span>This report shell is permission-protected. Its data source and business definitions must be approved before analytics are made available.</span>
        </div>
      </div>
    </section>
  );
}
